(function () {
  function initProductBannerCarousel(carouselRoot) {
    const track = carouselRoot.querySelector('[data-banner-carousel-track]');
    const slides = Array.from(carouselRoot.querySelectorAll('[data-banner-carousel-slide]'));
    if (!track || slides.length < 2) return;

    const dots = Array.from(carouselRoot.querySelectorAll('[data-banner-carousel-dot]'));
    const prevButton = carouselRoot.querySelector('[data-banner-carousel-prev]');
    const nextButton = carouselRoot.querySelector('[data-banner-carousel-next]');
    const isAutoplayEnabled = carouselRoot.getAttribute('data-autoplay') === 'true';
    const autoplayInterval = parseInt(carouselRoot.getAttribute('data-interval'), 10) || 5000;
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const SWIPE_THRESHOLD = 40;
    const DRAG_THRESHOLD = 10;

    let currentIndex = 0;
    let autoplayTimer = null;
    let touchStartX = null;
    let hasDragged = false;

    function goToSlide(index) {
      currentIndex = (index + slides.length) % slides.length;
      track.style.transform = 'translateX(' + -100 * currentIndex + '%)';
      slides.forEach(function (slide, slideIndex) {
        const isActive = slideIndex === currentIndex;
        const slideButton = slide.querySelector('button');
        slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        if (slideButton) slideButton.tabIndex = isActive ? 0 : -1;
      });
      dots.forEach(function (dot, dotIndex) {
        dot.classList.toggle('is-active', dotIndex === currentIndex);
      });
    }

    function stopAutoplay() {
      if (autoplayTimer) clearInterval(autoplayTimer);
      autoplayTimer = null;
    }

    function startAutoplay() {
      stopAutoplay();
      if (!isAutoplayEnabled || prefersReducedMotion) return;
      autoplayTimer = setInterval(function () {
        goToSlide(currentIndex + 1);
      }, autoplayInterval);
    }

    if (prevButton) prevButton.addEventListener('click', function () { goToSlide(currentIndex - 1); startAutoplay(); });
    if (nextButton) nextButton.addEventListener('click', function () { goToSlide(currentIndex + 1); startAutoplay(); });
    dots.forEach(function (dot, dotIndex) {
      dot.addEventListener('click', function () { goToSlide(dotIndex); startAutoplay(); });
    });

    carouselRoot.addEventListener('mouseenter', stopAutoplay);
    carouselRoot.addEventListener('mouseleave', startAutoplay);
    carouselRoot.addEventListener('touchstart', function (event) {
      touchStartX = event.touches[0].clientX;
      hasDragged = false;
      stopAutoplay();
    }, { passive: true });
    carouselRoot.addEventListener('touchmove', function (event) {
      if (touchStartX !== null && Math.abs(event.touches[0].clientX - touchStartX) > DRAG_THRESHOLD) hasDragged = true;
    }, { passive: true });
    carouselRoot.addEventListener('touchend', function (event) {
      if (touchStartX !== null) {
        const swipeDistance = event.changedTouches[0].clientX - touchStartX;
        if (Math.abs(swipeDistance) > SWIPE_THRESHOLD) goToSlide(currentIndex + (swipeDistance < 0 ? 1 : -1));
      }
      touchStartX = null;
      startAutoplay();
    });
    // Evita disparar o clique do banner ao arrastar
    carouselRoot.addEventListener('click', function (event) {
      if (hasDragged) {
        event.preventDefault();
        event.stopPropagation();
        hasDragged = false;
      }
    }, true);

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stopAutoplay();
      else startAutoplay();
    });

    startAutoplay();
  }

  function initProductBannerCarousels(scope) {
    const carousels = (scope || document).querySelectorAll('[data-banner-carousel]');
    Array.prototype.forEach.call(carousels, function (carousel) {
      if (carousel.__productBannerCarouselReady) return;
      carousel.__productBannerCarouselReady = true;
      initProductBannerCarousel(carousel);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initProductBannerCarousels(); });
  else initProductBannerCarousels();

  document.addEventListener('shopify:section:load', function (event) { initProductBannerCarousels(event.target); });
})();
